import React from "react";
import { Pagination } from "react-bootstrap";

import { searchListe } from "../searchList";

class ConditionsPagination extends React.Component {
  constructor(props) {
    super(props);
    this._page = 1;
    this._rows = 10;
    this._search = "";
    this._changed = false;
    // bind event listeners to this
    this.onChange = this.onChange.bind(this);
  }

  get page() {
    if (!isNaN(this.props.page)) return this.props.page;
    return this._page;
  }

  get rows() {
    if (!isNaN(this.props.rows)) return this.props.rows;
    return this._rows;
  }

  get search() {
    if (typeof this.props.search === "string") return this.props.search;
    return this._search;
  }

  get changed() {
    if (typeof this.props.changed === "boolean") return this.props.changed;
    return this._changed;
  }

  onChange(e) {
    if (this.props.disabled || !e || !e.target) return;
    e.preventDefault();
    let page;
    if (e.target.dataset && e.target.dataset.page) {
      page = e.target.dataset.page;
    } else if (e.target.parentNode && e.target.parentNode.dataset) {
      page = e.target.parentNode.dataset.page;
    }
    if (!page) return;
    // TODO update own local variables that are changed if no props are provided
    if (typeof this.props.onChange !== "function") return;
    this.props.onChange({ page: Number(page) });
  }

  getPagination(liste) {
    if (!liste || liste.length <= this.rows) return null;
    let items = [];
    let active = this.page;
    let pages = Math.ceil(liste.length / this.rows);
    let start = 1, end = pages;
    if (pages > 10) {
      items.push(<Pagination.First
        key="first"
        title="Zur ersten Seite"
        data-page={1}
        onClick={this.onChange}
      />);
      items.push(
        <Pagination.Prev
          key="prev"
          title="Zur vorherigen Seite"
          data-page={active > 1 ? active - 1 : null}
          onClick={this.onChange}
        />
      );
      if (active > 3) {
        items.push(<Pagination.Ellipsis key="s1" />);
        start = active - 2;
        if (active < pages - 3) {
          end = active + 2;
        } else {
          start = pages - 4;
        }
      } else {
        end = 5;
      }
    }
    for (let number = start; number <= end; number++) {
      items.push(
        <Pagination.Item
          key={number}
          title={`Zur Seite ${number} von ${pages}`}
          active={number === active}
          data-page={number}
          onClick={this.onChange}
        >
          {number}
        </Pagination.Item>,
      );
    }
    if (pages > 10) {
      if (active < pages - 3) items.push(<Pagination.Ellipsis key="s2" />);
      items.push(
        <Pagination.Next
          key="next"
          title="Zur nächsten Seite"
          data-page={active < pages ? active + 1 : null}
          onClick={this.onChange}
        />
      );
      items.push(<Pagination.Last
        key="last"
        title="Zur letzten Seite"
        data-page={pages}
        onClick={this.onChange}
      />);
    }
    return items;
  }

  render() {
    const data = Array.isArray(this.props.list) ? this.props.list : [];
    const paginationItems = this.getPagination(data.filter(item => searchListe(item, this.search, this.changed)));
    return (
      <Pagination>
        {paginationItems}
      </Pagination>
    );
  }
}

export default ConditionsPagination;
